export enum PowerUnit {
  // NOTE: Not an actual power unit, but used with generator's additional load
  // that can be provided in amperes.
  AMPERE = 'A',

  WATT = 'W',
  KILOWATT = 'kW',
  VOLT_AMPERE = 'VA',
  KILOVOLT_AMPERE = 'kVA'
}
